import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import { FieldComponentProps } from './types'
import { LabelWithInfo } from '../util'

const StreetField: React.FC<FieldComponentProps> = ({ field, name, disabled }) => {
  const { control } = useFormContext()
  const { t } = useTranslation()
  const required = !disabled && Boolean(field.fieldRequired)

  return (
    <>
      <FormFields.Input
        label={<LabelWithInfo label={t('Street')} info={field.info} required={required} />}
        placeholder={t('Enter street')}
        control={control}
        disabled={disabled}
        rules={required ? {
          required: {
            value: true,
            message: t('Please enter Street')
          }
        } : {}}
        name={`${name}.value`}
      />
      <FormFields.Input
        label={<LabelWithInfo label={t('Street number')} info={field.info} required={required} />}
        control={control}
        disabled={disabled}
        placeholder={t('Enter street number')}
        rules={required ? {
          required: {
            value: true,
            message: t('Please enter Street number')
          }
        } : {}}
        name={`${name}.value2`}
      />
    </>
  )
}

export default StreetField
